module.exports = __webpack_public_path__ + "static/media/29BDOS17.ea69d9c6.jpg";